import { useAuditoria } from "../contexts/AuditoriaContext";
import Enumerable from "linq";
import crypto from "../../Crypto";
import { ModeloGetUrlJson, ModeloPost } from "../../ModeloCrud";
import { toast } from "react-toastify";
import dayjs from "dayjs";

export const useAuditoriaUtils = () => {
  const {
    selectedDate,
    selectedClinica,
    selectedOdontologo,
    updateAuditoria,
    auditoriaActivaId,
    modoAuditoria,
    selectedRow,
    auditingRows,
    auditoriaPantalla,
  } = useAuditoria();

  const formatDate = (date) => date.toISOString().split("T")[0];

  const getLastDayOfMonth = (date) =>
    new Date(date.getFullYear(), date.getMonth() + 1, 0);

  const handlePrevMonth = () => {
    const newDate = new Date(selectedDate);
    newDate.setMonth(newDate.getMonth() - 1);
    updateAuditoria({ auditingRows: [], selectedDate: newDate });
    handleSearchPeriodo(newDate);
  };

  const handleNextMonth = () => {
    const newDate = new Date(selectedDate);
    newDate.setMonth(newDate.getMonth() + 1);
    updateAuditoria({ auditingRows: [], selectedDate: newDate });
    handleSearchPeriodo(newDate);
  };

  const handleDateChange = (newDate) => {
    // Convertimos la fecha a Day.js y nos aseguramos de que el día sea el primero del mes
    const normalizedDate = dayjs(newDate).startOf("month");

    // Verificamos si la fecha es válida
    if (!normalizedDate.isValid()) {
      console.error("Fecha inválida:", newDate);
      return; // Si la fecha no es válida, no hacemos nada
    }

    console.log("Fecha date field:", normalizedDate);
    console.log("Fecha seleccionada:", selectedDate);

    // Actualizamos el estado de selectedDate con el valor normalizado (Day.js)
    updateAuditoria({ selectedDate: normalizedDate.toDate() });

    // Llamamos a handleSearchPeriodo con la nueva fecha (convertimos Day.js a Date)
    handleSearchPeriodo(normalizedDate.toDate()); // `toDate()` convierte Day.js a un objeto Date
  };

  const filtrarOdontologosPorClinica = (clinicaId) => {
    const allcoes = crypto.decryptDataStorage("allcoes");

    return Enumerable.from(allcoes)
      .where((w) => w.centro_id === clinicaId)
      .groupBy((g) => g.odontologo_id)
      .select((e) => ({
        id: e.key(),
        odontologo: e.max((m) => m.odontologo),
      }))
      .toArray();
  };

  const handleSearch = async () => {
    if (!selectedClinica || !selectedOdontologo) {
      toast.info("Seleccione clínica y odontólogo.");
      return;
    }

    updateAuditoria({ auditingRows: [], loading: true });

    const params = new URLSearchParams({
      "fecha-desde": formatDate(selectedDate),
      "fecha-hasta": formatDate(getLastDayOfMonth(selectedDate)),
      odontologo_id: selectedOdontologo.id,
      centro_id: selectedClinica.id,
    });

    const response = await ModeloGetUrlJson(
      "tratamiento",
      null,
      "tratamientos-entre-fechas",
      params
    );

    updateAuditoria({ loading: false });

    if (response.error === false) {
      updateAuditoria({ auditingRows: response.listado });
      console.log("Respuesta de auditoria:", response);
    }
  };

  const handleSearchUrlPdf = async (ruta) => {
    if (!ruta) return null;

    const params = new URLSearchParams({ ruta });

    try {
      const response = await ModeloGetUrlJson(
        "buscar-url-archivo",
        null,
        null,
        params
      );

      if (response?.error === false && response?.url) {
        return response.url;
      } else {
        toast.warning("No se encontró el archivo o hubo un error.");
        return null;
      }
    } catch (error) {
      toast.error("Error al buscar la URL del PDF:", error);
      return null;
    }
  };

  const handleSearchPeriodo = async (date) => {
    const mes = date.getMonth() + 1; // getMonth() va de 0 (enero) a 11 (diciembre)
    const anio = date.getFullYear();
    updateAuditoria({ auditoriaPantalla: null });
    console.log("Buscando auditoría para:", mes, anio);
    const body = {
      anio: anio,
      mes: mes,
      tipo_busqueda: "and",
      comparacion_busqueda: "exacto",
    };
    const response = await ModeloPost("auditoria", null, "buscar", body);
    console.log("Respuesta de auditoría por período:", response);
    if (response.error === false) {
      updateAuditoria({ auditoriaPantalla: response.listado[0] });
    }
  };

  const handleGetResumenAuditoria = async () => {
    const params = new URLSearchParams({
      auditoriaId: auditoriaActivaId,
      centroId: selectedClinica.id,
    });

    updateAuditoria({ searchingResumen: true });
    const response = await ModeloGetUrlJson(
      "liquidacion",
      null,
      "obtener-auditoria-periodo",
      params
    );
    updateAuditoria({ searchingResumen: false });
    console.log("Respuesta de resumen de auditoria:", response);
    return response || []; // Retorna un array vacío si no hay datos
  };

  const handleGetExcelLiquidaciones = async () => {
    const params = new URLSearchParams({
      auditoriaId: auditoriaActivaId,
      centroId: selectedClinica.id,
    });

    updateAuditoria({ searchingResumenLiquidaciones: true });
    const response = await ModeloGetUrlJson(
      "liquidacion",
      null,
      "exportar-liquidaciones-excel",
      params
    );
    updateAuditoria({ searchingResumenLiquidaciones: false });
    console.log("Respuesta de excel de liquidacion:", response);
    return response || []; // Retorna un array vacío si no hay datos
  };

  const handleAuditarOdontologo = async () => {
    if (!modoAuditoria) {
      toast.warning(
        "La fecha seleccionada no coincide con la auditoría activa"
      );
      return; // cortar ejecución
    }
    updateAuditoria({ auditingOdontologo: true });
    updateAuditoria({
      auditingRows: auditingRows.map((r) => ({ ...r, auditando: true })),
    });
    const total = auditingRows.length;

    if (total <= 800) {
      // 🔹 Auditar todo junto (sin quincena)
      const body = {
        centro_id: selectedClinica.id,
        odontologo_id: selectedOdontologo.id,
      };

      console.log("Auditando todo junto (sin quincena)");
      try {
        const response = await ModeloPost(
          "auditoria",
          auditoriaActivaId,
          "ejecutar",
          body
        );

        if (!response.error && response.listado) {
          console.log("Respuesta de auditoría:", response);
          toast.success(response.listado, {
            autoClose: 2000, // en milisegundos (5 segundos)
          });
        } else {
          console.error("Error:", response.errormessage);
        }
      } catch (e) {
        console.error("Falló la auditoría:", e);
      }
    } else {
      // 🔹 Auditar por quincena
      const quincenas = [1, 2];

      for (const quincena of quincenas) {
        const body = {
          centro_id: selectedClinica.id,
          odontologo_id: selectedOdontologo.id,
          quincena,
        };

        toast.info("Auditando quincena: " + quincena);
        try {
          const response = await ModeloPost(
            "auditoria",
            auditoriaActivaId,
            "ejecutar",
            body
          );

          if (!response.error && response.listado) {
            console.log("Respuesta de auditoría:", response);
            // toast.success(`Quincena ${quincena}: ${response.listado}`);
          } else {
            console.error("Error en quincena", quincena, response.errormessage);
          }
        } catch (e) {
          console.error("Falló la auditoría en quincena", quincena, e);
        }
      }
      toast.success("Se auditaron todos los tratamientos.", {
        autoClose: 2000, // en milisegundos (5 segundos)
      });
    }
    //    }

    updateAuditoria({ auditingOdontologo: false });
    updateAuditoria({
      auditingRows: auditingRows.map((r) => ({ ...r, auditando: false })),
    });
    handleSearch();
  };

  const handleAuditarPaciente = async () => {
    if (!modoAuditoria) {
      toast.warning(
        "La fecha seleccionada no coincide con la auditoría activa"
      );
      return; // cortar ejecución
    }
    updateAuditoria({ auditingPaciente: true });
    console.log("Auditoría de paciente Selectedrow:", selectedRow.paciente_id);
    const pacienteId = selectedRow.paciente_id;
    updateAuditoria({
      auditingRows: auditingRows.map((r) =>
        r.paciente_id === pacienteId ? { ...r, auditando: true } : r
      ),
    });
    const body = {
      centro_id: selectedClinica.id,
      odontologo_id: selectedOdontologo.id,
      paciente_id: pacienteId,
    };

    try {
      const response = await ModeloPost(
        "auditoria", // entidad (usa el controlador AuditoriaController)
        auditoriaActivaId, // ID de la auditoría activa
        "ejecutar", // ruta tipo /auditoria/{id}/ejecutar
        body
      );

      updateAuditoria({ auditingPaciente: false });
      updateAuditoria({
        auditingRows: auditingRows.map((r) => ({ ...r, auditando: false })),
      });

      console.log("Respuesta de auditoría:", response);
      if (response.error === false) {
        //console.log("✅ Auditoría del paciente exitosa:", response);
        //toast.success("Auditoría realizada con éxito");
        const { listado } = response;

        updateAuditoria({
          auditingRows: auditingRows.map((row) => {
            const actualizado = listado.find(
              (r) => r.tratamiento_id === row.tratamiento_id
            );
            // Si se encontró un tratamiento actualizado, lo devol
            return actualizado
              ? {
                  ...row,
                  resultado_auditoria: actualizado.resultado_auditoria,
                  debitos: actualizado.debitos,
                  valor: actualizado.valor,
                }
              : row;
          }),
        });
        return response;
      } else {
        console.error("❌ Error al auditar paciente:", response.errormessage);
        toast.error(response.errormessage || "Error al ejecutar la auditoría");
        return { error: true, errormessage: response.errormessage };
      }
    } catch (error) {
      updateAuditoria({ auditingPaciente: false });
      console.error("❌ Error de red al auditar paciente:", error);
      toast.error("Error de conexión con el servidor");
      return { error: true, errormessage: "Error de conexión" };
    }
  };

  const handleNuevoPeriodo = async () => {
    updateAuditoria({ addingPeriodo: true });

    try {
      const response = await ModeloPost(
        "auditoria", // entidad (usa el controlador AuditoriaController)
        null, // ID de la auditoría activa
        "nuevo-periodo", // ruta tipo /auditoria/{id}/ejecutar
        null
      );
      updateAuditoria({ addingPeriodo: false });

      console.log("Respuesta de auditoría:", response);
      if (response.error === false) {
        //console.log("✅ Auditoría del paciente exitosa:", response);
        //toast.success("Auditoría realizada con éxito");
        toast.success(
          `Se creó el período ${response.listado.mes
            .toString()
            .padStart(2, "0")}/${response.listado.anio}`
        );
        return response;
      } else {
        console.error("❌ Error al crear un periodo:", response.errormessage);
        toast.error(response.errormessage || "Error al crear un período");
        return { error: true, errormessage: response.errormessage };
      }
    } catch (error) {
      updateAuditoria({ addinPeriodo: false });
      console.error("❌ Error al crear un período", error);
      toast.error("Error al crear un período.");
      return { error: true, errormessage: error };
    }
  };

  const aprobarRechazar = async ({ row, tipo, motivo = null }) => {
    if (!row?.tratamiento_id) {
      toast.error("Fila inválida");
      return;
    }

    let payload = {};

    if (tipo === "rechazar") {
      if (!motivo) {
        toast.error("Motivo es requerido");
        return;
      }
      payload = {
        reglas: motivo,
        usar_codigos: true,
      };
    }

    try {
      const response = await ModeloPost(
        "tratamiento",
        row.tratamiento_id,
        tipo,
        payload
      );
      return response;
    } catch (err) {
      toast.error("Error al actualizar auditoría");
      console.error(err);
    }
  };

  const handleMotivoSubmit = async ({
    motivo,
    motivoRow,
    auditingRows,
    updateAuditoria,
  }) => {
    const tratamientoId = motivoRow.tratamiento_id;

    updateAuditoria({
      auditingRows: auditingRows.map((r) =>
        r.tratamiento_id === tratamientoId ? { ...r, auditando: true } : r
      ),
    });

    const updated = await aprobarRechazar({
      row: motivoRow,
      tipo: "rechazar",
      motivo,
    });
    console.log("Respuesta de rechazo:", updated);
    if (updated && updated.error === false && updated.listado) {
      updateAuditoria({
        auditingRows: auditingRows.map((r) =>
          r.tratamiento_id === updated.listado.id
            ? {
                ...r,
                resultado_auditoria: updated.listado.resultado_auditoria,
                debitos: updated.listado.debitos,
                auditando: false,
              }
            : r
        ),
      });
    } else {
      updateAuditoria({
        auditingRows: auditingRows.map((r) =>
          r.tratamiento_id === tratamientoId ? { ...r, auditando: false } : r
        ),
      });

      toast.error(
        `No se pudo rechazar la prestación: ${
          updated?.errormessage || "error desconocido"
        }`
      );
    }
  };

  const handleActivarPeriodo = async () => {
    console.log("Activando período de auditoría");
    if (!auditoriaPantalla || auditoriaPantalla.length === 0) {
      toast.warning("No hay períodos para activar");
      return;
    }
    if (auditoriaPantalla.cerrada === 1) {
      toast.warning("Auditoria cerrada, no se puede activar");
      return;
    }
    const periodoId = auditoriaPantalla.id; // Asumiendo que quieres activar el primer período
    const response = await ModeloPost("auditoria", periodoId, "activar", null);
    console.log("Respuesta de auditoría:", response);
    if (response.error === false) {
      toast.success("Período activado correctamente");
      updateAuditoria({
        auditoriaActivaId: periodoId,
        auditoriaActivaFecha: new Date(
          response.listado.anio,
          response.listado.mes - 1,
          1
        ),
      });
    } else {
      toast.error(
        `Error al activar el período: ${
          response.errormessage || "error desconocido"
        }`
      );
    }
  };

  const handleAbrirCerrarPeriodo = async () => {
    console.log("Abriendo o cerrando período de auditoría ", auditoriaPantalla);
    if (!auditoriaPantalla || auditoriaPantalla.length === 0) {
      toast.warning("No hay períodos para abrir o cerrar");
      return;
    }
    if (auditoriaPantalla.activa === 1) {
      toast.warning("Auditoria activa, no se puede cambiar estado");
      return;
    }
    const periodoId = auditoriaPantalla.id;
    const operacion = auditoriaPantalla.cerrada ? "abrir" : "cerrar";
    const body = {
      operacion, // "abrir" o "cerrar"
    };
    const response = await ModeloPost(
      "auditoria",
      periodoId,
      "abrir-cerrar",
      body
    );
    console.log("Respuesta de auditoría:", response);
    if (response.error === false) {
      const periodoCerrado = response.listado.cerrada === 0;
      updateAuditoria({
        periodoCerrado, // Actualizamos el estado de cerrado
        auditoriaPantalla: response.listado,
      });
    } else {
      toast.error(
        `Error cambiar el estado: ${
          response.errormessage || "error desconocido"
        }`
      );
    }
  };

  return {
    aprobarRechazar,
    handlePrevMonth,
    handleNextMonth,
    handleSearch,
    filtrarOdontologosPorClinica,
    formatDate,
    getLastDayOfMonth,
    handleAuditarOdontologo,
    handleAuditarPaciente,
    handleNuevoPeriodo,
    handleMotivoSubmit,
    handleActivarPeriodo,
    handleAbrirCerrarPeriodo,
    handleDateChange,
    handleGetExcelLiquidaciones,
    handleGetResumenAuditoria,
    handleSearchUrlPdf,
  };
};
